import { render, staticRenderFns } from "./PatientAlertsInfoBox.vue?vue&type=template&id=f88eeda4&"
import script from "./PatientAlertsInfoBox.vue?vue&type=script&lang=js&"
export * from "./PatientAlertsInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports